export default {
  description: '當前頁面啟用的語言，消費者端切換語言時才能選到；消費者端頁面優先展示默認語言',
  language: '語言',
  defaultLanguage: '默認語言',
  enabled: '是否啟用',
  traditionalChinese: '繁體中文',
  simplifiedChinese: '簡體中文',
  english: 'English',
  japanese: 'Japanese',
  save: '保存',
  saveSuccess: '保存成功',
};
